<div class="gray-bg-rounded">
  <div class="today-task p-2">
    <p-accordion value="0">
      <p-accordion-panel value="0">
        <p-accordion-header>
          <div class="d-flex justify-content-between topboder mb-2">
            <span
              class="d-flex justify-content-between gap-2 align-items-top align-items-center">
              <span> <i class="pi pi-users"></i></span>
              <h2 class="mb-0">
                Collaborators
                <jni-spinner *ngIf="showSmallLoader"></jni-spinner>
              </h2>
            </span>
          </div>
        </p-accordion-header>
        <p-accordion-content class="border-0">
          <div class="today-list-bar">
            <div class="box-height overflow-auto">
              <div
                *ngIf="
                  !showSmallLoader && collaborators.length > 0;
                  else noList
                ">
                <div
                  *ngFor="let item of collaborators"
                  class="d-flex gap-1 mt-1 align-items-center pt-1 pb-1">
                  <div class="assign-name-box-purple rounded-circle p-2">
                    MJ
                  </div>
                  <div>
                    <h3 class="m-0">{{ item.username }}</h3>
                    <small>{{ item.title }}</small>
                  </div>
                </div>
              </div>

              <ng-template #noList>
                <div class="col-lg-12 today-list-bar gray-bg">
                  <div
                    class="lds-ring inline me-auto ms-2"
                    *ngIf="showSmallLoader">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                  <h3 *ngIf="!showSmallLoader">No list available.</h3>
                </div>
              </ng-template>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>
</div>
